import { getAdminAxiosInstance } from "../../../api/Admin";

export const updateSubscriptionAccess = async (params) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.post(`subscription-setting/update`, params);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};

export const viewSubscriptionAccess = async (id) => {
  const api = await getAdminAxiosInstance();
  try {
    const response = await api.get(`subscription-setting/edit?id=${id}`);
    return response;
  } catch (error) {
    return error?.response?.data;
  }
};
